import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import NC2SVG from '../../../assets/icons/clouds/nc2.svg?raw';

export const NC2Logo = (props) => <CustomSVG svg={NC2SVG} preserveColors {...props} />;
